import React from "react";
import Card from "components/card";
import { Minus, Plus, X, Sparkles } from "lucide-react";
import Button from "components/button";
import { getVoucherMeta } from "variables/constants";

const CartVoucher = ({ voucherItem, onRemove, onUpdateQuantity}) => {
   if (!voucherItem) return null;

    const { voucher, quantity } = voucherItem;
    const { icon: Icon, gradientFrom, gradientTo } = getVoucherMeta(voucher.description);

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border dark-mode-card">
            <div className="pb-6 p-4">
                <div className="flex gap-4">
                    <div className={`w-20 h-20 rounded-xl bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center flex-shrink-0`}> 
                        {Icon && <Icon className="w-10 h-10 text-white" />}
                    </div>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-medium text-[14px] line-clamp-1 title-text">
                            {voucher.title}
                        </h4>
                        <p className="text-[11px] muted-text">
                            {voucher.description}
                        </p>
                        <div className="flex items-center gap-4 mt-2">
                            <div className="flex items-center gap-2"> 
                                <Button
                                    className="access-button btn-sign !w-7 !p-0 border !rounded-lg"
                                    onClick={() => onUpdateQuantity(voucher, -1)}
                                >
                                    <Minus className="w-3 h-3" />
                                </Button>

                                <span className="text-[14px] font-medium w-8 text-center title-text">{quantity}</span>

                                 <Button
                                    className="access-button btn-sign !w-7 !p-0 border !rounded-lg"
                                    onClick={() => onUpdateQuantity(voucher, +1)}
                                >
                                    <Plus className="w-3 h-3" />
                                </Button>
                            </div>
                            <div className="flex items-center gap-1 text-emerald-600 dark:text-emerald-500">
                                <Sparkles className="w-4 h-4" />
                                <span className="font-bold">{voucher.points * quantity}</span>
                            </div>
                        </div>
                    </div>
                    <Button
                        className="access-button btn-x"
                        onClick={() => onRemove?.(voucher)}
                    >
                        <X className="w-4 h-4" />
                    </Button>
                </div>
            </div>
        </Card>
    )
};
export default CartVoucher;